import ScheduleRepository from '../../domain/repositories/ScheduleRepository';
import ScheduleDataStoreFactory from '../factories/ScheduleDataStoreFactory';
import ScheduleDataStore from '../datastores/ScheduleDataStore';

export default class ScheduleDataRepository implements ScheduleRepository {
  getSchedule(date: number, periods: string[]) {
    const scheduleDataStore: ScheduleDataStore =
      ScheduleDataStoreFactory.create();
    return scheduleDataStore.getSchedule(date, periods);
  }

  getScheduleByDay(startDate: number, period: string) {
    const scheduleDataStore: ScheduleDataStore =
      ScheduleDataStoreFactory.create();
    return scheduleDataStore.getScheduleByDay(startDate, period);
  }

  getScheduleResumeHome(periodId: string) {
    const scheduleDataStore: ScheduleDataStore =
      ScheduleDataStoreFactory.create();
    return scheduleDataStore.getScheduleResumeHome(periodId);
  }
}
